export default "__VITE_ASSET__B6cHRZoi__"